module.exports = __webpack_public_path__ + "static/media/doremi_00000_journey_forest_before.6857b555.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/doremi_00000_journey_forest_before.png
// module id = 218
// module chunks = 0